import { PreClassActivity } from '../stories/CountdownWidget/CountdownWidgetContent';
import { LiveClassType } from '../stories/LiveClassTag';

interface UserContext {
  p2lEmbeddedZoomPlayerEnabled: boolean;
  p2lEmbeddedZoomPlayerMobileEnabled: boolean;
  referralProgramAvailable: boolean;
}

interface Announcement {
  title: string;
  body: string;
}

export interface User {
  email?: string;
  firstName?: string;
  lastName?: string;
  profilePicture?: string;
  username?: string;
  announcement?: Announcement;
  subscriptionInfo: SubscriptionInfo;
  nextLiveClass: UserNextLiveClass | null;
  lang: string;
  timezone?: string;
  timezoneOptions?: { [key: string]: string };
  unlockedOrientation: boolean;
  platformTourVideoPlayerUrl: string | null;
  orientationClassTaken: boolean;
  context?: UserContext;
  isGameClassKahootBeta: boolean;
}

interface SubscriptionInfo {
  groupSubscriptionCredited: number;
  groupSubscriptionTotal: number;
  groupSubscriptionTaken: number;
  groupSubscriptionAvailable: number;
  privateSubscriptionCredited: number;
  privateSubscriptionTotal: number;
  privateSubscriptionTaken: number;
  privateSubscriptionAvailable: number;
  renewDate: string;
  hasSubscriptionTypeUnlimitedGroup: boolean;
  hasSubscriptionTypePrivate: boolean;
}

export interface UserNextLiveClass {
  liveClassId: number;
  startAt: string; // e.g "2022-12-08T23:30:00+00:00"
  startInSeconds: number;
  topic: string;
  isGame: boolean;
  isOrientation: boolean;
  isPrivate: boolean;
  isConfirmed: boolean;
  preClassActivities?: PreClassActivity[];
}

export const getNextLiveClassType = (nextLiveClass: UserNextLiveClass): LiveClassType => {
  if (nextLiveClass.isGame) {
    return 'gameclass';
  }
  if (nextLiveClass.isOrientation) {
    return 'orientation';
  }
  if (nextLiveClass.isPrivate) {
    return 'private';
  }
  return 'group';
};
